import { render, staticRenderFns } from "./unit-card.vue?vue&type=template&id=18e81f7a&scoped=true"
import script from "./unit-card.vue?vue&type=script&lang=js"
export * from "./unit-card.vue?vue&type=script&lang=js"
import style0 from "./unit-card.vue?vue&type=style&index=0&id=18e81f7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e81f7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e81f7a')) {
      api.createRecord('18e81f7a', component.options)
    } else {
      api.reload('18e81f7a', component.options)
    }
    module.hot.accept("./unit-card.vue?vue&type=template&id=18e81f7a&scoped=true", function () {
      api.rerender('18e81f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/units/components/unit-card.vue"
export default component.exports